import { upcomingIposRepository } from '@/features/upcoming-ipos/api/upcomingIposRepository';

export class UpcomingIposController {
  constructor(repository = upcomingIposRepository) {
    this.repository = repository;
    this.status = 'idle';
    this.items = [];
    this.meta = {
      counts: { total: 0, upcoming: 0, recent: 0 },
      ranges: { upcomingFrom: '', upcomingUntil: '', recentSince: '' },
      countryOptions: [{ key: 'all', label: 'Todos los países permitidos' }],
      filters: { query: '', country: 'all' }
    };
    this.error = null;
  }

  async load(filters) {
    this.status = this.items.length ? 'refreshing' : 'loading';
    this.error = null;

    try {
      const result = await this.repository.search(filters);
      this.items = result.items;
      this.meta = result.meta;
      this.status = 'ready';
      return result;
    }
    catch (error) {
      this.items = [];
      this.status = 'error';
      this.error = error;
      throw error;
    }
  }
}
